module.exports = __webpack_public_path__ + "static/media/perche-4.9e88a101.svg";